.campo {
  display: flex;
  flex-direction: column;
  gap: var(--s-4);
  min-width: 0;
}
/* La etiqueta y lo que va a su derecha (un contador), en una línea. */
.cabecera {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--s-4);
}
.etiqueta {
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  color: var(--text-strong);
}
/* La etiqueta de un control deshabilitado se apaga con él. */
.campo:has(:disabled) .etiqueta {
  color: var(--control-disabled-text);
}
.obligatorio {
  margin-left: var(--s-1);
  color: var(--text-brand);
}
.mensaje {
  font-family: var(--font-body);
  font-size: var(--fs-2xs);
  line-height: var(--lh-normal);
  color: var(--text-muted);
}
.campo[data-error] .mensaje {
  color: var(--text-danger);
}
